module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeueCyr-Bold.a9a80ec.woff";